<template>
    <nav class="navbar navbar-light wg-blue">
        <ul class="navbar-nav mt-2 mt-lg-0 w-25">
            <li class="nav-item">
<!--                <a class="nav-link text-white" href="#">{{ title }} </a>-->
            </li>
        </ul>
        <div class="text-white d-flex flex-column w-50">
            <img src="../assets/images/WaterGuru-Logo.svg" class="logo" alt="">
        </div>
        <div class="w-25 d-flex flex-column flex-sm-row justify-content-between">
            <span class="text-white" v-if="user"><span class="d-none d-sm-inline">Logged in as:</span> {{ username }}</span>
            <a :href="`https://${WEBAPP_URL}/#/auth/signOut?q=${APP_URL}`" v-if="user" class="text-white">Logout</a>
        </div>
    </nav>
</template>

<script>
import { Auth } from 'aws-amplify'
import { WEBAPP_URL } from '../amplify/config'

export default {
    name: 'NavBar',
    props: ['title'],
    data () {
        return {
            user: null,
            WEBAPP_URL,
            APP_URL: location.origin
        }
    },
    computed: {
        username () {
            const attr = this.user.attributes
            return attr.given_name + ' ' + attr.family_name
        }
    },
    created () {
        try {
            Auth.currentAuthenticatedUser().then(user => {
                this.user = user
            }).catch(() => {
                this.user = null
            })
        } catch (e) {
            this.user = null
        }
    }
}
</script>

<style scoped>
    .wg-blue {
        background-color: #0098c5 !important;
    }
    .logo {
        width: 91px;
        margin: 0 auto;
    }
</style>
